// extracted by mini-css-extract-plugin
module.exports = {"container":"nav_dropdown_footer-module__container--UpHgO"};